"use strict";
var BoundCallbackObservable_1 = require("./BoundCallbackObservable");
exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/bindCallback.js
 ** module id = 185
 ** module chunks = 1
 **/